import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import CloseIcon from "@material-ui/icons/Close";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { IconButton, InputAdornment, Tooltip } from "@material-ui/core";
import * as Icons from "@material-ui/icons";

function DropdownAutoComplete(props) {
  const { options, onChange, name, label, value, tooltip } = props;
  const selectedOption = value
    ? options.find((option) => option.value === (value.value || value))
    : null;
  const [open, setOpen] = React.useState(false);

  return (
    <Autocomplete
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      options={Array.isArray(options) ? options : []} // Ensure options is an array
      getOptionLabel={(option) => option.key}
      name={name}
      value={selectedOption} // Find the option that matches the selected value
      onChange={onChange} // Handle the change event
      disableClearable
      renderInput={(params) => (
        <TextField
          required={props.required}
          {...params}
          autoComplete="off"
          label={label}
          variant="outlined"
          className={props.className}
          ref={params.InputProps.ref}
          InputProps={{
            ...params.InputParams,
            endAdornment: (
              <InputAdornment position="end">
                <div className="flex-row" style={{ alignItems: "end" }}>
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() => {
                      setOpen(!open);
                    }}>
                    <KeyboardArrowDownIcon />
                  </IconButton>
                  {selectedOption && (
                    <IconButton
                      onClick={() => {
                        onChange(null, "");
                      }}
                      size="small">
                      <CloseIcon />
                    </IconButton>
                  )}
                  {tooltip ? (
                    <Tooltip title={tooltip} arrow>
                      <Icons.Help
                        style={{
                          verticalAlign: "middle",
                          fontSize: "16px",
                          marginLeft: "5px",
                          marginBottom: "5px",
                        }}
                        color="primary"
                      />
                    </Tooltip>
                  ) : null}
                </div>
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  );
}

export default DropdownAutoComplete;
